module.exports = __webpack_public_path__ + "files/b31643bfdad29385c6b1da393ab4649f.png";